import { Component } from '@angular/core'
import { SharedModule } from '@src/app/shared/shared.module.js'

@Component({
  selector: 'app-verified-email-banner',
  templateUrl: 'verified-email-banner.component.html',
  styleUrls: ['verified-email-banner.component.scss'],
  imports: [SharedModule],
})
export class VerifiedEmailBannerComponent {}
